import Disclaimer from '@components/Consents/Disclaimer';
import StructuredData from '@components/StructuredData';
import { disclaimerStructuredData } from '@helpers/constants';
import { HeadTagData } from '@helpers/headTagData';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import {useEffect} from "react";
import {logEvent, moengageEventConstants} from "@services/moengage";

const DisclaimerPage = () => {
    useEffect(() => {
        logEvent({eventName: moengageEventConstants.VIEWED_DISCLAIMER_PAGE,});
    }, []);
    return (
        <>
            <NextHeadTag {...HeadTagData?.['/disclaimer']} />
            <StructuredData data={disclaimerStructuredData} />
            <Disclaimer />
        </>
    );
};

export default DisclaimerPage;
